import { StatsBannerCMS } from '@cerifi/ui/cms/stats-banner/stats-banner-cms'

import { ComponentStatsBanner } from '../../../__generated/graphql.types'

const StatsBanner = (props: { content: ComponentStatsBanner }) => {
  return (
    <StatsBannerCMS
      id={props.content.sys.id}
      isH1={(props.content as any).IS_H1}
      title={props.content.title}
      alignment={props.content.alignment as string}
      iconChoiceStat1={props.content.iconChoiceStat1 as string}
      iconChoiceStat2={props.content.iconChoiceStat2 as string}
      iconChoiceStat3={props.content.iconChoiceStat3 as string}
      stat1Subtitle={props.content.stat1Subtitle}
      stat2Subtitle={props.content.stat2Subtitle}
      stat3Subtitle={props.content.stat3Subtitle}
      stat1Text={props.content.stat1Text as string}
      stat2Text={props.content.stat2Text as string}
      stat3Text={props.content.stat3Text as string}
      color={props.content.color}
      padding={props.content.padding as boolean}
      titleTextSize={props.content.titleTextSize as string}
    />
  )
}

export default StatsBanner
